import { useReduxState } from 'hooks';
import { getMyTeamFollowHref } from 'lib/supervisors';
import { PageInnerContent, PageSidebar } from 'components/page';
import { MyTeamFollowProvider, MyTeamPage } from 'components/supervisors';

import type { IconProp } from 'components/common/icons/Icon';

const MyTeamFollowPage = ({ activeLink = '', children }) => {
  const {
    messages,
    pageState: { supervisor },
    serverConfig
  } = useReduxState();

  const achievementsVisible = !serverConfig.hideAchievementsFromUI;
  const calendarEventsVisible = !serverConfig.hideCalendarEventsFromUI;
  const coursesVisible = !serverConfig.hideCoursesFromUI;
  const pathsVisible = !serverConfig.hidePathsFromUI;

  const basePath = '/my-team/follow';
  const hasPendingAccessRequests = supervisor?.pendingAccessRequests > 0;

  const sidebarLinks = [
    ...(coursesVisible
      ? [
          {
            as: `${basePath}/courses`,
            href: `${basePath}/courses`,
            icon: 'book' as const,
            title: messages.commonCourses
          }
        ]
      : []),
    ...(pathsVisible
      ? [
          {
            as: `${basePath}/paths`,
            href: `${basePath}/paths`,
            icon: 'tasks' as const,
            title: messages.commonPaths
          }
        ]
      : []),
    ...(achievementsVisible
      ? [
          {
            as: `${basePath}/achievements`,
            href: `${basePath}/achievements`,
            icon: 'check-circle' as const,
            title: messages.commonAchievementsAlt
          }
        ]
      : []),
    ...(calendarEventsVisible
      ? [
          {
            as: `${basePath}/calendar-events`,
            href: `${basePath}/calendar-events`,
            icon: ['far', 'calendar-days'] as IconProp,
            title: messages.commonCalendarEvents
          }
        ]
      : []),
    ...(achievementsVisible
      ? [
          {
            as: `${basePath}/pending-requests`,
            href: `${basePath}/pending-requests`,
            icon: 'hourglass-start' as const,
            title: messages.commonPendingRequests,
            unreadItems: supervisor?.pendingAccessRequests
          }
        ]
      : [])
  ];

  return (
    <MyTeamPage
      activeLink={getMyTeamFollowHref({
        hasPendingAccessRequests,
        relative: true,
        serverConfig
      })}
      withSidebar={true}
    >
      <PageSidebar active={`${basePath}${activeLink}`} links={sidebarLinks} />
      <PageInnerContent>
        <MyTeamFollowProvider>{children}</MyTeamFollowProvider>
      </PageInnerContent>
    </MyTeamPage>
  );
};

export default MyTeamFollowPage;
